import React from 'react';
import { useField } from "formik";
import Select, { components } from "react-select";
import { InputLabel } from "@mui/material";
import { ValidationError } from '@thrivetribe/mvf.ui.atoms.validation-error';
import "./formik-select.scss"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <ExpandMoreIcon fontSize="large" />
    </components.DropdownIndicator>
  );
};

export type FormikSelectProps = {
  name: string;
  options: any[];
  label?: string;
  placeholder?: string;
  [key: string]: any;
};

export const FormikSelect = (props: FormikSelectProps) => {
  const { name, options, label, placeholder = "Select an option", ...otherProps } = props;
  const [field, meta, helpers] = useField(name);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: "none",
      color: "#1e222f",
      fontSize: "20px",
      lineHeight: "27px",
      fontFamily: "Avenir, Arial, sans-serif",
      padding: 10,
      backgroundColor: state.isSelected ? "#f6f6f6" : "inherit",
      fontWeight: state.isSelected ? "bold" : "300",
      "&:hover": {
        backgroundColor: "#F4F6F6",
        fontWeight: "bold",
      },
    }),
    control: (provided, state) => ({
      ...provided,
      "&:hover": { outline: meta.touched && meta.error ? "1px solid #ed0000" : "1px solid #1e222f" },
      borderRadius: "0px",
      border: meta.touched && meta.error
        ? "1px solid #ed0000"
        : "1px solid #1e222f",
      outline: state.isFocused
        ? "3px solid #8894e1"
        : meta.touched && meta.error
          ? "1px solid #ed0000"
          : "none",
      boxShadow: "none",
      backgroundColor: "#ffffff",
      fontSize: "20px",
      fontWeight: "300",
      lineHeight: "27px",
      fontFamily: "Avenir, Arial, sans-serif",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transition: "all .2s ease",
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
      svg: {
        fill: "#1e222f",
        height: "25px",
        width: " 25px",
      },
    }),
    menu: (provided) => ({
      ...provided,
      border: `1px solid #1e222f`,
      outline: `1px solid #1e222f`,
      boxShadow: "none",
      marginTop: "-2px",
      borderTop: "none",
      borderRadius: "0px",
      padding: "0px",
    }),
    menuPortal: (provided) => ({
      ...provided,
      marginBottom: "50px",
    }),
    input: (provided) => ({
      ...provided,
      color: "#1e222f",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuIsOpen ? "#000000" : "#00000080",
      fontWeight: state.selectProps.menuIsOpen ? "500" : "300"
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e222f",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
  };

  return (
    <>
      {label !== undefined && (
        <label htmlFor={`${name}-input`} className="select-input__label">
          {label}
        </label>
      )}

      <Select
        name={name}
        id={name}
        inputId={`${name}-input`}
        value={field.value}
        className="select-input"
        onChange={(value) => helpers.setValue(value)}
        options={options}
        components={{ DropdownIndicator }}
        onBlur={() => helpers.setTouched(true)}
        styles={customStyles}
        placeholder={placeholder}
        {...otherProps}
      />
      {meta.error != undefined && meta.touched && (
        <ValidationError errorMessage={meta.error} />
      )}

      {!meta.error && meta.touched && otherProps.errorMessage && <ValidationError errorMessage={otherProps.errorMessage} />}
    </>
  );
};
